import { Domain } from '@/types/common/enums';

export const getDefaultLoanAmount = () => {
  if (window.config.DOMAIN === Domain.LV) {
    return 6000;
  }

  return 0;
};
